/** @jsxImportSource react */

import { useShare } from '@common/helpers/share';
import { getTypeformProps } from '@react/cta/helpers/getEventProps';
import TypeformWizard from '@react/cta/TypeformWizard/Wizard';
import { typeformFormId } from 'sly/config';

import { ToolHero } from './Styles';
import { ToolDetails } from '../types';

export default function CareQuizTool({
  toolProp,
  heading,
  description,
  shortDescription,
}: ToolDetails) {
  const typeformId = toolProp?.typeformId || typeformFormId;

  const { share } = useShare();

  return (
    <>
      <ToolHero
        heading={heading}
        subheading={description}
        onShare={() => {
          share({
            title: heading,
            text: shortDescription || description || '',
            url: window.location.href,
          });
        }}
      />
      <div className='h-[578px]'>
        <TypeformWizard
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          {...getTypeformProps({
            name: 'embeddedTypeform',
            nonInteraction: 1,
          })}
          isConversionForm={false}
          //eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          wizardType='WIDGET'
          formId={typeformId}
        />
      </div>
    </>
  );
}
